import { render, staticRenderFns } from "./InactiveCandidateView.vue?vue&type=template&id=15f637fe&"
import script from "./InactiveCandidateView.vue?vue&type=script&lang=js&"
export * from "./InactiveCandidateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports